import React, { useState } from 'react';
import { Carousel, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import slide1 from '../Medias/Photos/photo-bg1.jpg';

const SectionCarousel = ({ contents }) => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const mockup = [
    {
      row_value: slide1,
      detail:
        <>
          <Row>
            <Col>
              <h1 className='font-header'>PT & Associates</h1>
              <h3>Creative Legal Strategies</h3>
            </Col>
          </Row>
          <Row>
            <Col>Our boutique law firm PT & Associates (PTA) is known for its multi-disciplinary perspectives for solving legal and regulatory challenges for our clients in the energy industry both in the private and government sectors. Our professional team brings expertise from diverse academic and industry backgrounds to formulate and implement legal strategies that address our clients’ business needs. Our services consist of inventive legal solutions tailored to deliver client-determined optimal results.
            </Col>
            <Col>Beyond providing legal services, PTA maintains the not-for-profit Energy Law Center (ELC) with the generous support of corporate social responsibility (CSR) donors who share our vision of creating an open and neutral platform for energy law scholarship and discussions. The ELC serves as a forum for community outreach — supporting news and events, regulatory updates, energy education and trends, and publications — that provides general information to various stakeholders to understand the economic and social value of energy law.
            </Col>
          </Row>
        </>
    }
  ];

  return (
    <>
      <section id="home">
        <Carousel activeIndex={index} onSelect={handleSelect}>
          {mockup.map((item, index) => (
            <Carousel.Item key={index} className="rps-carousel bg-img" style={{ backgroundImage: 'url(' + item.row_value + ')' }}>
              <div className="position-absolute w-100 h-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}>
                <Carousel.Caption className="top-50 start-50 translate-middle text-start px-0 px-md-5">
                  {item.detail}
                  <Button size='lg' as={Link} to='/Service' className='bg-color-primary border-0 me-3 mt-3 p-1 p-md-3 px-2 px-md-5'>Services</Button>
                  <Button size='lg' as={Link} to='/Contact' className='bg-white text-black border-0 me-3 mt-3 p-1 p-md-3 px-2 px-md-5'>Contact Us</Button>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>
    </>
  )
}

SectionCarousel.defaultProps = {
  contents: []
}

export default SectionCarousel